import { put, call, fork, join, delay } from 'redux-saga/effects'

import * as types from '../actions/actionTypes'
import { getInflowHistoriesSuccessAction } from '../actions/inflowHistoryActions'
import { setSnackbarErrorAction } from '../actions/snackbarActions'
import * as api from '../api'
import { getErrorMessage } from '../domain/Errno'
import { attemptRefreshToken } from './userSaga'

export function* getInflowHistoriesSaga({ payload: timestampTz }) {
  try {
    yield put({ type: types.FETCHING })
    const refreshTokenTask = yield fork(attemptRefreshToken)
    yield join(refreshTokenTask)

    yield delay(100)

    const res = yield call(api.requestGetInflowHistories, timestampTz)
    yield put(getInflowHistoriesSuccessAction(res.data, !timestampTz))
  } catch (err) {
    console.error('getInflowHistoriesSaga', err)
    const message = getErrorMessage(err)
    yield put({ type: types.GET_INFLOW_HISTORIES_ERROR })
    yield put(setSnackbarErrorAction(message))
  } finally {
    yield put({ type: types.FETCH_COMPLETE })
  }
}

export function* getInflowHistoryDetailSaga({ payload: transactionId }) {
  try {
    yield put({ type: types.FETCHING })
    const refreshTokenTask = yield fork(attemptRefreshToken)
    yield join(refreshTokenTask)

    const res = yield call(api.requestGetInflowHistoryDetail, transactionId)
    yield put({
      type: types.GET_INFLOW_HISTORY_DETAIL_SUCCESS,
      payload: {
        transactionId,
        data: res.data,
      },
    })
  } catch (err) {
    console.error('getInflowHistoryDetailSaga', err)
    const message = getErrorMessage(err)
    yield put({
      type: types.GET_INFLOW_HISTORY_DETAIL_ERROR,
      payload: { transactionId },
    })
    yield put(setSnackbarErrorAction(message))
  } finally {
    yield put({ type: types.FETCH_COMPLETE })
  }
}
